import { Tooltip } from 'antd'
import React from 'react'

import { CreatorRevenue } from '@/model/analytics'
import { formatPrice } from '@/utils/formatter'

import s from './top-creators.module.css'

export interface TopCreatorsProps {
  creatorRevenues?: CreatorRevenue[]
}

export default function TopCreators({
  creatorRevenues,
}: TopCreatorsProps) {
  return (
    <div className={s.CreatorList}>
      {creatorRevenues?.map(({ name, earnings }, index) => (
        <div key={name} className={s.CreatorItem}>
          <div className={s.CreatorName}>
            <div className={s.Ranking}>{index + 1}</div>
            <span>
              <Tooltip title={name}>
                {name}
              </Tooltip>
            </span>
          </div>
          <div className={s.Revenue}>
            <Tooltip title={formatPrice({ currency: '' })(earnings)}>
              {formatPrice()(earnings)}
            </Tooltip>
          </div>
        </div>
      ))}
    </div>
  )
}